<template>
  <div class="container-dashboard container-dashboard-home">
    <div class="logo-overlay">
      <!-- <img src="@/assets/img/FirstStep-RGB-Line.png" alt="FirstStep" /> -->
    </div>
    <div class="container">
      <div class="row">
        <div class="col-24 mx-auto">
          <div class="card card--dashboard">
            <div class="card-body card-body--dashboard">
              <h1 class="text-center h1 h1--dashboard">
                {{ 'What Would You Like To Do Today?' | translate }}
              </h1>
              <router-link
                v-if="!user"
                to="/login/"
                class="btn btn-dashboard btn-block"
                active-class="active"
                exact
                >{{ 'Log In' | translate }}</router-link
              >
              <!--							<router-link v-if="!user" to="/login/" class="btn btn-dashboard btn-block" active-class="active" exact>{{"Economic/ROI Calculator" | translate}}</router-link>-->
              <router-link
                v-if="user"
                to="/quick-start/"
                class="btn btn-dashboard mt-2"
                :class="{
                  'disabled-btn': user.role === 'intro' && allEvaluations.length >= 5,
                }"
                active-class="active"
                exact
                @click.native.prevent="
                  user.role === 'intro' && allEvaluations.length >= 5
                    ? null
                    : $router.push('/quick-start/')
                "
                >{{ 'Quick Start Evaluation' | translate }}</router-link
              >
              <router-link
                v-if="user"
                to="/evaluations/new"
                class="btn btn-dashboard mt-2"
                :class="{
                  'disabled-btn': user.role === 'intro' && allEvaluations.length >= 5,
                }"
                active-class="active"
                exact
                @click.native.prevent="
                  user.role === 'intro' && allEvaluations.length >= 5
                    ? null
                    : $router.push('/evaluations/new')
                "
                >{{ 'Start New Evaluation' | translate }}</router-link
              >
              <router-link
                v-if="user"
                to="/evaluations"
                class="btn btn-dashboard mt-2"
                active-class="active"
                exact
                >{{ 'View Evaluations' | translate }}</router-link
              >
              <router-link
                v-if="user && user.role !== 'data_entry'"
                to="/reports"
                class="btn btn-dashboard mt-2"
                active-class="active"
                exact
                >{{ 'Create A Report' | translate }}</router-link
              >
              <router-link
                v-if="user && $store.state.adminRoles.includes(user.role)"
                to="/admin/invite-customer"
                :class="['btn', 'btn-dashboard', 'mt-2', { disabled: !isOnline }]"
                active-class="active"
                exact
                >{{ 'Invite A Customer' | translate }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Informational Modal for Intro users with 3 evaluations -->
    <div
      v-if="showIntroLimitModal"
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-labelledby="introLimitModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog--edit" role="document">
        <div class="modal-content edit-modal pt-0 px-0">
          <div class="modal-body my-0 py-0 px-0">
            <h2 class="h2 pt-3 pb-2 px-3 text-center">
              {{ 'Thank you for your interest in Zinpro® FirstStep®!' | translate }}
            </h2>
            <p class="px-3 mb-4">
              {{
                'You have completed your limited trial access to the program. To upgrade your account to unlimited Evaluations and the complete set of Assessors, please contact your Zinpro® Representative.'
                  | translate
              }}
            </p>
            <div class="px-3 mb-4 text-center">
              <a
                href="https://www.zinpro.com/contact-sales/?_expert_type=representative"
                target="_blank"
                class="btn btn-secondary"
              >
                {{ 'Contact Zinpro Representative' | translate }}
              </a>
            </div>
            <div class="row modal-bottom pb-3">
              <button @click="closeIntroLimitModal" class="btn btn-secondary">
                {{ 'OK' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showIntroLimitModal" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader';
import AppFooter from '../components/AppFooter';
import { mapActions, mapGetters, mapState } from 'vuex';
import { GET_COMPANIES } from '../store/types';
export default {
  name: 'home',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      showIntroLimitModal: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
      allEvaluations: (state) => state.evaluations.evaluations,
      // isOnline: state => state.isOnline,
    }),
    ...mapGetters(['isOnline']),
    shouldShowIntroLimitModal() {
      return (
        this.user &&
        this.user.role === 'intro' &&
        this.allEvaluations &&
        this.allEvaluations.length >= 5
      );
    },
  },
  methods: {
    ...mapActions('company', [GET_COMPANIES]),
    closeIntroLimitModal() {
      this.showIntroLimitModal = false;
    },
    checkAndShowIntroLimitModal() {
      if (this.shouldShowIntroLimitModal) {
        this.showIntroLimitModal = true;
      }
    },
  },
  created() {
    this[GET_COMPANIES]();
    console.log({ isOnline: this.isOnline });
    // Temporary hide home page from guests
    // if (!this.user || !this.user._id) {
    // 	this.$router.push('/login')
    // }
    // this.user = this.$store.getters.getData('user');
  },
  mounted() {
    this.checkAndShowIntroLimitModal();
  },
  watch: {
    // Watch for changes in user or evaluations to show modal when returning to home
    user: {
      handler() {
        this.checkAndShowIntroLimitModal();
      },
      deep: true,
    },
    allEvaluations: {
      handler() {
        this.checkAndShowIntroLimitModal();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled-btn {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
  background-color: #ccc !important;
  border-color: #ccc !important;

  &:hover {
    background-color: #ccc !important;
    border-color: #ccc !important;
  }
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.modal.show {
  z-index: 1050;
}
</style>
